export const alertStatus = {
	error: 'error',
	warning: 'warning',
	good: 'good'
};

class Condition {
	constructor(apicontrolStatusCondition = {}) {
		this.expression = apicontrolStatusCondition.expression;
		this.trueMsg = apicontrolStatusCondition.trueMsg;
		this.falseMsg = apicontrolStatusCondition.falseMsg;
	}
}

export class AlertOption {
	constructor(apicontrolStatus = {}) {
		(this.name = apicontrolStatus.name),
			(this.datapointIds = apicontrolStatus.datapointIds || []),
			(this.class = apicontrolStatus.icon),
			(this.errorMsg = apicontrolStatus.errorMsg),
			(this.conditions = (apicontrolStatus.conditions || []).map(
				apicondition => new Condition(apicondition)
			));
	}

	getdatapointseries(equipment = {}, datapointId) {
		let db, value;
		db =
			equipment.onei3 && equipment.onei3.series
				? equipment.onei3.series[datapointId]
				: 'undefined';
		value = db && db.last ? db.last.v : 'undefined';
		return { db, value };
	}

	//function
	calcStatus(equipment) {
		let result = {};

		const [dbId0, dbId1] = this.datapointIds;

		if (this.datapointIds.length === 0) {
			result.status = alertStatus.error;
			result.text = 'No data point specified!';
			return result;
		} else if (this.datapointIds.length === 1) {
			var { db: db0, value: value0 } = this.getdatapointseries(
				equipment,
				dbId0
			);
			var db1 = true;
		} else {
			var { db: db0, value: value0 } = this.getdatapointseries(
				equipment,
				dbId0
			);
			var { db: db1, value: value1 } = this.getdatapointseries(
				equipment,
				dbId1
			);
		}

		if (db0 && db1) {
			const [firstcond] = this.conditions;
			if (!firstcond) {
				result.status = alertStatus.good;
				result.text = '';
			} else {
				if (eval(firstcond.expression)) {
					result.status = alertStatus.good;
					result.text = firstcond.trueMsg;
				} else {
					result.status = alertStatus.error;
					result.text = firstcond.falseMsg;
				}
			}
		} else {
			result.status = alertStatus.error;
			result.text = this.errorMsg;
		}

		return result;
	}
}
